import { Directive, ElementRef, Input } from '@angular/core';
import { GeometryType } from 'src/app/core/api/models';

@Directive({
    selector: '[geometryType]',
    standalone: true
})
export class GeometryTypeDirective {

    @Input() geometryType: GeometryType;

    constructor(private element: ElementRef<HTMLElement>) { }

    ngOnInit(): void {
        this.element.nativeElement.className = this.getCssClassList();
    }

    getCssClassList(): string {

        let classList = "mdi tw-font-bold mdi-20px badge ";

        switch (this.geometryType) {
            case GeometryType.Aerodrome:
                classList += 'mdi-airplane badge-light-purple';
                break;
            case GeometryType.Hospital:
                classList += 'mdi-hospital-box badge-light-navyBlue';
                break;
            case GeometryType.Hotel:
                classList += 'mdi-bed badge-light-blue';
                break;
            case GeometryType.Mall:
                classList += 'mdi-shopping badge-light-warning';
                break;
            case GeometryType.Motel:
                classList += 'mdi-bed-outline badge-light-pink';
                break;
            case GeometryType.Restaurant:
                classList += 'mdi-silverware-fork-knife badge-light-success';
                break;
            case GeometryType.Unknown:
                classList += 'mdi-crosshairs-question badge-light-dark';
                break;

            default:
                break;
        }
        return classList;
    }

}
